<template>
  <div class="app-container activity-type">
    <div class="activity-type-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="activity-type-list-filter-value" v-model.trim="search.name" @keyup.enter.native="getList" placeholder="名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="activity-type-list-filter-reset" size="small" @click="searchReset">清除条件</el-button>
            <el-button class="activity-type-list-filter-search" size="small" @click="searchChange">立即筛选</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container>
      <avue-crud 
        ref="crud"
        :option="tableOption"
        :data="tableData"
        :page="page"
        :table-loading="tableLoading"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        @sort-change="handleSortChange">

        <template slot="menuLeft">
          <el-button v-if="permissions.activity_type_add" type="primary" icon="el-icon-plus" size="small" @click="$router.push({path:'/app/activity/type/add'})">新增</el-button>
        </template>

        <template slot-scope="scope" slot="menu">
          <el-button v-if="permissions.activity_type_edit" type="text" icon="el-icon-edit" size="small" @click="toEdit(scope.row)">编辑</el-button>
          <el-button v-if="permissions.activity_type_del" :disabled="scope.row.isLocked" type="text" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>

      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { activityTypesTableOption } from '@/const/crud/app/activity';
import Api from '@/api/app/activity';
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      tableOption: activityTypesTableOption,
      tableData: [],
      tableLoading: false,
      search: {
        current: 1,
        size: 10,
        sortField: "",
        sortPolicy: "",
        name: "",
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.getList();
  },
  activated() {
    this.getList();
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    isNotBlank(param) {
      return param !== '' && param.trim() !== '';
    },
    getList() {
      let params = {
        current: this.search.current,
        size: this.search.size,
      };

      if (this.isNotBlank(this.search.name)) {
        params.name = this.search.name;
      }

      if (this.isNotBlank(this.search.sortField)) {
        params.sortField = this.search.sortField;
      } else {
        params.sortField = 'inserted_time';
      }

      if (this.isNotBlank(this.search.sortPolicy)) {
        params.sortPolicy = this.search.sortPolicy;
      } else {
        params.sortPolicy = 'desc';
      }
      this.tableLoading = true;
      Api.getActivityTypeList(params).then(response => {
        if (response.data.code === 0) {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total;
          this.tableLoading = false;
        } else {
          this.$message.error(response.data.msg);
        }
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除此培训类型吗? 类型删除后，此类型下的所有培训移动到“其他”类型。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        Api.removeActivityType(id).then(() => {
          this.getList();
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000,
          });
        });
      });
    },
    searchReset() {
      this.page.currentPage = 1;
      this.page.pageSize = this.search.size;
      this.search.current = 1;
      this.search.sortField = '';
      this.search.sortPolicy = '';
      this.search.name = '';
      this.getList();
    },
    searchChange() {
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.search.current = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.search.size = val;
      this.getList();
    },
    handleSortChange(val) {
      if (val.prop == 'inserted_time') {
        this.search.sortField = 'inserted_time';
      } else {
        this.search.sortField = '';
      }
      if (val.order == 'ascending') {
        this.search.sortPolicy = 'asc';
      } else if (val.order == 'descending') {
        this.search.sortPolicy = 'desc';
      } else {
        this.search.sortPolicy = '';
      }
      this.getList();
    },
    toEdit(row) {
      this.$router.push({ path:'/app/activity/type/edit/' + row.id, query: { name: row.name } });
    }
  }
};
</script>

<style lang="scss" scoped>
.activity-type {
  &-list-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-value {
      width: calc(100% - 12px) !important;
    }
    &-reset {
      margin-left: 10px;
    }
    &-search {
      margin-left: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
}
</style>
